// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@rpsc/App/Components/Notify";
import { changeCustomerSelectCustomerContainerStyles } from "@rpsc/Overrides/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { mergeWithCss, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionHidden = {
    css: css`
        display: none;
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    css: css`
        font-size: 12px;
        margin-top: 20px;
    `,
};

changeCustomerSelectCustomerContainerStyles.container = {
    gap: 20,
    css: css`
        max-width: 450px;

        ${xScreen("gt", "md")} {
            max-width: 600px;
            margin: 0;
        }
    `,
};

changeCustomerSelectCustomerContainerStyles.useDefaultCustomerDescriptionVisible = {
    ...mergeWithCss(getNotifyStyle("info"), {
        css: css`
            margin-top: 20px;
            margin-bottom: 0;
        `,
    }),
};

changeCustomerSelectCustomerContainerStyles.cancelButton = {
    variant: "tertiary",
    css: css`
        margin-right: 15px;
        min-height: 33px;
    `,
};
